import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteMatchEvent, deleteAllMatchEvents } from "@/api/matches";
import { MatchesQueryKeys } from "@/tanstackQuery/queries/matches";
import { invalidateMatchLists } from "./invalidateMatchLists";

export const useDeleteMatchEvent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ matchId, eventId }: { matchId: string; eventId: number }) =>
      deleteMatchEvent(matchId, eventId),
    onSuccess: () => {
      invalidateMatchLists(queryClient);
    },
  });
};

export const useDeleteAllMatchEvents = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (matchId: string) => deleteAllMatchEvents(matchId),
    onSuccess: () => {
      invalidateMatchLists(queryClient);
    },
  });
};
